"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

declare global {
  interface Window {
    minimizeCXoneChat?: () => void;
  }
}

export default function CxoneNavigationHandler() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined" && window.minimizeCXoneChat) {
      window.minimizeCXoneChat();
    }
  }, [pathname]);

  return null;
}
